"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationBase = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const theme_1 = require("../../theme");
const ConversationBase = ({ children, image, showContentBottomBorder = false, }) => {
    const theme = theme_1.useSharedTheme();
    return (react_1.default.createElement(react_native_1.View, { style: styles.container },
        image ? react_1.default.createElement(react_native_1.View, { style: styles.imageWrapper }, image) : null,
        react_1.default.createElement(react_native_1.View, { style: [
                styles.content,
                showContentBottomBorder ? styles.contentBottomBorder : undefined,
                showContentBottomBorder
                    ? { borderBottomColor: theme.colors.divider }
                    : undefined,
            ] }, children)));
};
exports.ConversationBase = ConversationBase;
const styles = react_native_1.StyleSheet.create({
    container: {
        flexDirection: 'row',
        paddingTop: 8,
    },
    content: {
        flex: 1,
        minHeight: 50,
        paddingBottom: 8,
    },
    contentBottomBorder: {
        borderBottomWidth: react_native_1.StyleSheet.hairlineWidth,
    },
    imageWrapper: {
        alignItems: 'center',
        marginRight: 16,
        paddingBottom: 8,
    },
});
